export default __webpack_public_path__ + "static/media/charge.09b77347.svg";